import es6Promise from 'es6-promise'
es6Promise.polyfill()

import Vue from 'vue'
import App from './App.vue'

import constants from './constants'

import moment from 'moment'

// ROUTER SETUP
import router from './routes/router'
import store from './store'

// DESIGN PLUGIN SETUP
import DashboardPlugin from './plugins/dashboard-plugin'
Vue.use(DashboardPlugin)

import titleMixin from '@/mixins/titleMixin'
Vue.mixin(titleMixin)

import './registerServiceWorker'
import './lib/bugsnag.js'

//JWT Library Setup
import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

if (store.getters.token) {
  Vue.axios.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${store.getters.token}`
}

//Handle get new token from refresh token when old token expired
Vue.axios.interceptors.request.use(
  async (config) => {
    if (store.getters.token) {
      if (
        !config.url.includes('/token/refresh') &&
        !config.url.includes('/login') &&
        !config.url.includes('/logout')
      ) {
        const decodeToken = Vue.$jwt.decode(store.getters.token)
        const expired = decodeToken.exp
        const now = moment().unix()
        if (expired - constants.beforeExpiredTime <= now) {
          const { data } = await Vue.axios.post(
            process.env.VUE_APP_ROOT_API + '/api/v1/token/refresh',
            {
              clientKey: process.env.VUE_APP_SECRET,
              clientType: process.env.VUE_APP_TYPE,
              refreshToken: store.getters.refreshToken
            }
          )
          store.commit('SET_TOKEN', data)
          Vue.axios.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${data.token}`
          config.headers.Authorization = `Bearer ${data.token}`
        }
      }
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

import VueGtag from 'vue-gtag'
Vue.use(
  VueGtag,
  {
    config: { id: 'UA-1176295-62' }
  },
  router
)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

import VueNativeNotification from 'vue-native-notification'
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})

import Loading from 'vue-loading-overlay'
Vue.use(Loading, {
  color: '#E1001E'
})
Vue.component('loading', Loading)
import 'vue-loading-overlay/dist/vue-loading.css'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  store,
  router
})
